import React from 'react'
import PropTypes from 'prop-types'

const IconCustomers = ({ className }) => (
  <svg className={className} viewBox="0 0 15 9">
    <path d="M13.125 0.125V8.875H14.375V0.125H13.125ZM10.625 8.875H11.875V0.125H10.625V8.875ZM8.75 0.125H1.25C0.90625 0.125 0.625 0.40625 0.625 0.75V8.25C0.625 8.59375 0.90625 8.875 1.25 8.875H8.75C9.09375 8.875 9.375 8.59375 9.375 8.25V0.75C9.375 0.40625 9.09375 0.125 8.75 0.125ZM5 1.84375C5.775 1.84375 6.40625 2.475 6.40625 3.25C6.40625 4.025 5.775 4.65625 5 4.65625C4.225 4.65625 3.59375 4.025 3.59375 3.25C3.59375 2.475 4.225 1.84375 5 1.84375ZM7.8125 7.625H2.1875V7.15625C2.1875 6.21875 4.0625 5.75 5 5.75C5.9375 5.75 7.8125 6.21875 7.8125 7.15625V7.625Z"/>
  </svg>

)

IconCustomers.propTypes = {
  className: PropTypes.string,
}

export default IconCustomers
